import {post, get} from '@/utils/request'

// 查询用户列表
export function listUser(query) {
    return get(
        '/sys/user/list',
        query
    )
}

// 查询用户列表（范围内，用于带训人等选择）
export function listUserScope(query) {
    return get(
        '/sys/user/list/scope',
        query
    )
}
// 查询用户详细
export function getMe() {
    return get(
        '/sys/user/me',
    )
}

// 查询用户详细
export function getUser(userId) {
    return get(
        '/sys/user/get/' + userId,
    )
}

// 新增用户
export function addUser(data) {
    return post(
        '/sys/user/add',
        data,
        'json'
    )
}

// 修改用户
export function updateUser(data) {
    return post(
        '/sys/user/edit',
        data,
        'json'
    )
}

// 修改用户密码
export function updateUserPassword(data) {
    return post(
        '/sys/user/edit/password',
        data,
        'json'
    )
}
export function resetUserPassword(userId) {
    return post(
        '/sys/user/reset/password/'+userId
    )
}

// 删除用户
export function delUser(userId) {
    return get(
        '/sys/user/remove/' + userId,
        'delete'
    )
}
